import { Card } from 'app/components/ui/Card'
import { Text } from 'app/components/ui/Text'
import { formatDateShort } from 'app/utils/dateUtils'
import {
  sponsorRequestStatusColor,
  sponsorRequestStatusDictionary,
} from 'app/utils/sponsorRequest'
import { SponsorRequest, SponsorRequestPaymentTerms } from 'EstraSponsor'
import React from 'react'
import styled, { useTheme } from 'styled-components'

type Props = {
  sponsorRequest: SponsorRequest
}

const PAYMENT_TERMS: Record<SponsorRequestPaymentTerms, string> = {
  '30': '30 gg fine mese data fattura',
  '120': '120 gg fine mese data fattura',
  '60': '60 gg fine mese data fattura',
  '90': '90 gg fine mese data fattura',
  immediato: 'ordine di pagamento immediato',
}

const SPONSOR_KITS = {
  ESTRA:
    'https://res.cloudinary.com/estra/raw/upload/v1642417029/Sponsorizzazioni/Loghi%20e%20Manuale/Loghi_Manuale_Estra.zip',
  PROMETEO:
    'https://res.cloudinary.com/estra/raw/upload/v1680519470/Sponsorizzazioni/Loghi%20e%20Manuale/Loghi_Manuale_EstraPrometeo.zip',
}

const getSponsorKit = (companyBrand: string): string =>
  // Return Prometeo sponsor kit if id === 3 (Prometeo), or the generic estra one for the other cases
  companyBrand === 'Estra'
    ? SPONSOR_KITS.ESTRA
    : companyBrand === 'Prometeo'
    ? SPONSOR_KITS.PROMETEO
    : '404'
// In case the PROMETEO zip is needed again use this line instead: companyId === 3 ? SPONSOR_KITS.PROMETEO : SPONSOR_KITS.ESTRA

export const SponsorRequestDetailsCard = ({
  sponsorRequest,
}: Props): JSX.Element => {
  const theme = useTheme()

  return (
    <div style={{ gridArea: 'Details' }}>
      <Card shadow padding={'3rem'} mobilePadding={'2rem'}>
        <Text mb={2} variant='s24' weight='700'>
          DETTAGLI
        </Text>
        <ListItem>
          <Text variant='s20'>Stato richiesta:</Text>
          <Text
            variant='s20'
            color={
              theme.color.primari[
                sponsorRequestStatusColor[sponsorRequest.status]
              ]
            }
          >
            {sponsorRequestStatusDictionary[sponsorRequest.status]}
          </Text>
        </ListItem>
        <ListItem>
          <Text variant='s20'>Data richiesta:</Text>
          <Text variant='s20' color={theme.color.primari.grigioEstra}>
            {formatDateShort(sponsorRequest.created_at)}
          </Text>
        </ListItem>
        {sponsorRequest.payment_terms ? (
          <ListItem>
            <Text variant='s20'>Pagamento:</Text>
            <Text variant='s20' color={theme.color.primari.grigioEstra}>
              {PAYMENT_TERMS[sponsorRequest.payment_terms]}
            </Text>
          </ListItem>
        ) : null}

        {sponsorRequest.status === 'finalized' && sponsorRequest.brand_name ? (
          <DocumentsList>
            <Text variant='s20'>
              <a
                href={getSponsorKit(sponsorRequest.brand_name)}
                target='_blank'
                rel='noopener noreferrer'
              >
                Scarica il kit di sponsorizzazione
              </a>
            </Text>
          </DocumentsList>
        ) : null}
        {sponsorRequest.status !== 'expired' &&
        sponsorRequest.status !== 'canceled' &&
        sponsorRequest.status !== 'rejected' ? (
          <DocumentsList>
            <Text variant='s20' weight='700' mb={1}>
              Documenti importanti per la fatturazione.
            </Text>
            <Text variant='s20' mb={0.5}>
              <a
                href='https://res.cloudinary.com/estra/image/upload/v1598977565/Estra%20Marketing/docs/Comunicazione_ai_fornitori.pdf'
                target='_blank'
                rel='noopener noreferrer'
              >
                Informazioni per lo split payment
              </a>
            </Text>
            <Text variant='s20'>
              <a
                href='https://res.cloudinary.com/estra/image/upload/v1598977567/Estra%20Marketing/docs/Lettera_fatturazione_elettronica.pdf'
                target='_blank'
                rel='noopener noreferrer'
              >
                Informazioni sulla fatturazione elettronica
              </a>
            </Text>
          </DocumentsList>
        ) : null}
      </Card>
    </div>
  )
}

const ListItem = styled.div`
  display: grid;
  row-gap: 0.5rem;

  border-top: 1px solid ${({ theme }) => theme.color.neutri.grigioBg};
  padding: 1rem 0rem;

  @media (min-width: ${({ theme }) => theme.bp.tablet}) {
    grid-template-columns: 2fr 3fr;
    column-gap: 2rem;
  }
`

const DocumentsList = styled.div`
  margin-top: 2rem;
`
